<template>
  <a-modal
    title="消息提醒"
    :width="800"
    :visible="visible"
    :confirmLoading="loading"
    :mask="true"
    :maskClosable="false"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
    ok-text="去处理"
  >
    <span>温馨提示：以下设备云服务授权即将到期，未避免影响使用，还请即使处理！</span>
    <a-table
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      :loading="loading"
    >
    </a-table>
  </a-modal>
</template>
<script>


export default {
  name: "CloudAuthExpiredDeviceModal",
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    tableData: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      columns: this.getColumns(),
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      form: this.$form.createForm(this),
      isDisabled: true,
      invoiceType: "2",
      titleType: "2",
      disabledPerson: false
    }
  },
  created() {

  },
  watch: {

  },
  methods: {
    getColumns(){
      return [
        {
          title: '设备名称',
          dataIndex: 'deviceName',
          key: 'deviceName',
        },
        {
          title: '设备SN',
          dataIndex: 'deviceSn',
          key: 'deviceSn',
        },
        {
          title: '总金额',
          dataIndex: 'deviceTypeCode',
          key: 'deviceTypeCode',
          scopedSlots: { customRender: 'deviceTypeCode' }
        },
        {
          title: '到期时间',
          dataIndex: 'expiredAt',
          key: 'expiredAt'
        },
      ]
    },
    handleOk(){
      //关闭模态框 跳转到充值页面
      this.$emit('cancel', this.editForm)
      this.$router.push({ name: 'rechargeIndex' });
    },
  }
}
</script>
